export {};

// helper method for swapping item indice in array
declare global {
	// tslint:disable-next-line
	interface Array<T> {
		swapItems(a: number, b: number): void;
	}
}

Array.prototype.swapItems = function (a, b) {
	this[a] = this.splice(b, 1, this[a])[0];
	return this;
};
